import React from "react";
import { Modal, Button } from "react-bootstrap";

function HiddenItemNotificationModal({ show, onHide, message, translations }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{translations.contentInDevelopment}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {translations.understood}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default HiddenItemNotificationModal;


